tinymce.addI18n("sl_SI", {
    "#": "#",
    "Accessibility": "Dostopnost",
    "Accordion": "Harmonika",
    "Accordion body...": "Telo harmonike...",
    "Accordion summary...": "Povzetek harmonike...",
    "Action": "Dejanje",
    "Activity": "Dejavnost",
    "Address": "Naslov",
    "Advanced": "Napredno",
    "Align": "Poravnava",
    "Align center": "Sredinska poravnava",
    "Align left": "Leva poravnava",
    "Align right": "Desna poravnava",
    "Alignment": "Poravnava",
    "Alignment {0}": "Poravnava {0}",
    "All": "Vse",
    "Alternative description": "Nadomestni opis",
    "Alternative source": "Nadomestni vir",
    "Alternative source URL": "Nadomestni vir URL",
    "Anchor": "Sidro",
    "Anchor...": "Sidro ...",
    "Anchors": "Sidra",
    "Animals and Nature": "\u017divali in narava",
    "Arrows": "Pu\u0161\u010dice",
    "B": "B",
    "Background color": "Barva ozadja",
    "Background color {0}": "Barva ozadja {0}",
    "Black": "\u010crna",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Blok citat",
    "Blocks": "Bloki",
    "Blue": "Modra",
    "Blue component": "Modra komponenta",
    "Body": "Vsebina",
    "Bold": "Krepko",
    "Border": "Meja",
    "Border color": "Barva obrobe",
    "Border style": "Slog obrobe",
    "Border width": "\u0160irina obrobe",
    "Bottom": "Dno",
    "Browse files": "Brskanje po datotekah",
    "Browse for an image": "Prebrskaj za sliko",
    "Browse links": "Brskajte po povezavah",
    "Bullet list": "Ozna\u010den seznam",
    "Cancel": "Prekli\u010di",
    "Caption": "Naslov",
    "Cell": "Celica",
    "Cell padding": "Polnilo med celicami",
    "Cell properties": "Lastnosti celice",
    "Cell spacing": "Razmik med celicami",
    "Cell styles": "Slogi celice",
    "Cell type": "Tip celice",
    "Center": "Sredinska",
    "Characters": "Znaki",
    "Characters (no spaces)": "Znaki (brez presledkov)",
    "Circle": "Krog",
    "Class": "Razred",
    "Clear formatting": "Odstrani oblikovanje",
    "Close": "Zapri",
    "Code": "Koda",
    "Code sample...": "Vzor\u010dna koda ...",
    "Code view": "Prikaz kode",
    "Color Picker": "Izbirnik barve",
    "Color swatch": "Vzorec barv",
    "Cols": "Stolpci",
    "Column": "Stolpec",
    "Column clipboard actions": "Dejanja odlo\u017ei\u0161\u010da v stolpcu",
    "Column group": "Grupiranje stolpcev",
    "Column header": "Glava stolpca",
    "Constrain proportions": "Obdr\u017ei razmerje",
    "Copy": "Kopiraj",
    "Copy column": "Kopiraj stolpec",
    "Copy row": "Kopiraj vrstico",
    "Could not find the specified string.": "Iskanje ni vrnilo rezultatov.",
    "Could not load emojis": "Emod\u017eijev ni bilo mogo\u010de nalo\u017eiti",
    "Count": "\u0160tevilo",
    "Currency": "Valuta",
    "Current window": "Trenutno okno",
    "Custom color": "Barva po meri",
    "Custom...": "Po meri ...",
    "Cut": "Izre\u017ei",
    "Cut column": "Izre\u017eite stolpec",
    "Cut row": "Izre\u017ei vrstico",
    "Dark Blue": "Temno modra",
    "Dark Gray": "Temno siva",
    "Dark Green": "Temno zelena",
    "Dark Orange": "Temno oran\u017ena",
    "Dark Purple": "Temno vijoli\u010dna",
    "Dark Red": "Temno rde\u010da",
    "Dark Turquoise": "Temno turkizna",
    "Dark Yellow": "Temno rumena",
    "Dashed": "\u010crtkano",
    "Date/time": "Datum/\u010das",
    "Decrease indent": "Zmanj\u0161aj zamik",
    "Default": "Privzeto",
    "Delete accordion": "Izbri\u0161i harmoniko",
    "Delete column": "Izbri\u0161i stolpec",
    "Delete row": "Izbri\u0161i vrstico",
    "Delete table": "Izbri\u0161i tabelo",
    "Dimensions": "Dimenzije",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Pikasto",
    "Double": "Dvojno",
    "Drop an image here": "Spusti sliko sem",
    "Dropped file type is not supported": "Vrsta odlo\u017eene datoteke ni podprta",
    "Edit": "Uredi",
    "Embed": "Vdelaj",
    "Emojis": "Emod\u017eiji",
    "Emojis...": "Emod\u017eiji ...",
    "Error": "Napaka",
    "Error: Form submit field collision.": "Napaka: navzkri\u017eje polja za oddajo obrazca",
    "Error: No form element found.": "Napaka: elementa oblike ni mogo\u010de najti",
    "Extended Latin": "Raz\u0161irjena latinica",
    "Failed to initialize plugin: {0}": "Napaka inicializacije vti\u010dnika: {0}",
    "Failed to load plugin url: {0}": "Napaka nalaganja url: {0}",
    "Failed to load plugin: {0} from url {1}": "Napaka nalaganja vti\u010dnika: {0} z url {1}",
    "Failed to upload image: {0}": "Napaka nalaganja slike: {0}",
    "File": "Datoteka",
    "Find": "Najdi",
    "Find (if searchreplace plugin activated)": "I\u0161\u010di (\u010de je aktiviran vti\u010dnik za iskanje/zamenjavo)",
    "Find and Replace": "Najdi in zamenjaj",
    "Find and replace...": "Najdi in zamenjaj ...",
    "Find in selection": "I\u0161\u010di v izboru",
    "Find whole words only": "I\u0161\u010di samo cele besede",
    "Flags": "Zastave",
    "Focus to contextual toolbar": "Poudarek na kontekstualni orodni vrstici",
    "Focus to element path": "Poudarek na poti elementa",
    "Focus to menubar": "Poudarek na menijski vrstici",
    "Focus to toolbar": "Poudarek na orodni vrstici",
    "Font": "Pisava",
    "Font size {0}": "Velikost pisave {0}",
    "Font sizes": "Velikost pisave",
    "Font {0}": "Pisava {0}",
    "Fonts": "Pisave",
    "Food and Drink": "Hrana in pija\u010da",
    "Footer": "Noga",
    "Format": "Oblika",
    "Format {0}": "Oblika {0}",
    "Formats": "Oblika",
    "Fullscreen": "\u010cez cel zaslon",
    "G": "G",
    "General": "Splo\u0161no",
    "Gray": "Siva",
    "Green": "Zelena",
    "Green component": "Zelena komponenta",
    "Groove": "Utor",
    "Handy Shortcuts": "Uporabne bli\u017enjice",
    "Header": "Glava",
    "Header cell": "Celica glave",
    "Heading 1": "Naslov 1",
    "Heading 2": "Naslov 2",
    "Heading 3": "Naslov 3",
    "Heading 4": "Naslov 4",
    "Heading 5": "Naslov 5",
    "Heading 6": "Naslov 6",
    "Headings": "Naslovi",
    "Height": "Vi\u0161ina",
    "Help": "Pomo\u010d",
    "Hex color code": "Hex barvna koda",
    "Hidden": "Skrito",
    "Horizontal align": "Vodoravna poravnava",
    "Horizontal line": "Vodoravna \u010drta",
    "Horizontal space": "Vodoravni prostor",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID se mora za\u010deti s \u010drko, ki ji sledijo samo \u010drke, \u0161tevilke, pomi\u0161ljaji, pike, dvopi\u010dje ali pod\u010drtaji.",
    "Image is decorative": "Slika je okrasna",
    "Image list": "Seznam slik",
    "Image title": "Naslov slike",
    "Image...": "Slika ...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP napaka: ImageProxy ni mogo\u010de najti",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP napaka: Napa\u010den ImageProxy URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP napaka: Zavrnjena zahteva",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP napaka:  Neznana ImageProxy napaka",
    "Increase indent": "Pove\u010daj zamik",
    "Inline": "Med besedilom",
    "Insert": "Vstavi",
    "Insert Template": "Vstavi predlogo",
    "Insert accordion": "Vstavi harmoniko",
    "Insert column after": "Vstavi stolpec za",
    "Insert column before": "Vstavi stolpec pred",
    "Insert date/time": "Vstavi datum/\u010das",
    "Insert image": "Vnesi sliko",
    "Insert link (if link plugin activated)": "Vstavi povezavo (\u010de je aktiviran vti\u010dnik za povezavo)",
    "Insert row after": "Vstavi vrstico za",
    "Insert row before": "Vstavi vrstico pred",
    "Insert table": "Vstavi tabelo",
    "Insert template...": "Vstavi predlogo ...",
    "Insert video": "Vstavi video",
    "Insert/Edit code sample": "Vstavi/Uredi vzor\u010dno kodo",
    "Insert/edit image": "Vstavi/uredi sliko",
    "Insert/edit link": "Vstavi/uredi povezavo",
    "Insert/edit media": "Vstavi/uredi medij",
    "Insert/edit video": "Vstavi/uredi video",
    "Inset": "Globinsko vtisnjeno",
    "Invalid hex color code: {0}": "Neveljavna hex barvna koda: {0}",
    "Invalid input": "Neveljaven vnos",
    "Italic": "Po\u0161evno",
    "Justify": "Obojestranska poravnava",
    "Keyboard Navigation": "Krmarjenje s tipkovnico",
    "Language": "Jezik",
    "Learn more...": "Ve\u010d ...",
    "Left": "Leva",
    "Left to right": "Od leve proti desni",
    "Light Blue": "Svetlo modra",
    "Light Gray": "Svetlo siva",
    "Light Green": "Svetlo zelena",
    "Light Purple": "Svetlo vijoli\u010dna",
    "Light Red": "Svetlo rde\u010da",
    "Light Yellow": "Svetlo rumena",
    "Line height": "Vi\u0161ina vrstice",
    "Link list": "Seznam povezav",
    "Link...": "Povezava ...",
    "List Properties": "Lastnosti seznama",
    "List properties...": "Lastnosti seznama...",
    "Loading emojis...": "Nalaganje emod\u017eijev ...",
    "Loading...": "Nalaganje...",
    "Lower Alpha": "Mala alfa",
    "Lower Greek": "Male gr\u0161ke \u010drke",
    "Lower Roman": "Male rimske \u0161tevilke",
    "Match case": "Ujemanje malih in velikih \u010drk",
    "Mathematical": "Matemati\u010dno",
    "Media poster (Image URL)": "Medijski poster (URL slike)",
    "Media...": "Mediji ...",
    "Medium Blue": "Srednje modra",
    "Medium Gray": "Srednje siva",
    "Medium Purple": "Srednje \u0161krlatna",
    "Merge cells": "Zdru\u017ei celice",
    "Middle": "Sredina",
    "Midnight Blue": "Polno\u010dno modra",
    "More...": "Ve\u010d ...",
    "Name": "Naziv",
    "Navy Blue": "Mornarsko modra",
    "New document": "Nov dokument",
    "New window": "Novo okno",
    "Next": "Naslednja",
    "No": "Ne",
    "No alignment": "Brez poravnave",
    "No color": "Brezbarvno",
    "Nonbreaking space": "Nedeljivi presledek",
    "None": "Brez",
    "Numbered list": "O\u0161tevil\u010den seznam",
    "OR": "ALI",
    "Objects": "Predmeti",
    "Ok": "V redu",
    "Open help dialog": "Odpri pogovorno okno za pomo\u010d",
    "Open link": "Odpri povezavo",
    "Open link in...": "Odpri povezavo v ...",
    "Open popup menu for split buttons": "Odpri pojavni meni za razdeljene gumbe",
    "Orange": "Oran\u017ena",
    "Outset": "Reliefno",
    "Page break": "Prelom strani",
    "Paragraph": "Odstavek",
    "Paste": "Prilepi",
    "Paste as text": "Vnesi kot besedilo",
    "Paste column after": "Vstavi stolpec za",
    "Paste column before": "Vstavi stolpec pred",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Odlagali\u0161\u010de je sedaj v tekstovnem na\u010dinu. Vsebina bo preslikana kot besedilo, dokler te mo\u017enosti ne izklju\u010dite.",
    "Paste or type a link": "Prilepite ali vnesite povezavo",
    "Paste row after": "Prilepi vrstico za",
    "Paste row before": "Prilepi vrstico pred",
    "Paste your embed code below:": "Spodaj prilepite kodo za vdelavo:",
    "People": "Ljudje",
    "Plugins": "Vti\u010dniki",
    "Plugins installed ({0}):": "Name\u0161\u010deni vti\u010dniki ({0}):",
    "Powered by {0}": "Uporablja tehnologijo {0}",
    "Pre": "Pre",
    "Preferences": "Preference",
    "Preformatted": "Predformatirano",
    "Premium plugins:": "Premium vti\u010dniki:",
    "Press the Up and Down arrow keys to resize the editor.": "Pritisnite pu\u0161\u010di\u010dni tipki gor in dol, da spremenite velikost urejevalnika.",
    "Press the arrow keys to resize the editor.": "Pritisnite pu\u0161\u010di\u010dne tipke, da spremenite velikost urejevalnika.",
    "Press {0} for help": "Pritisnite {0} za pomo\u010d",
    "Preview": "Predogled",
    "Previous": "Prej\u0161nja",
    "Print": "Tiskaj",
    "Print...": "Natisni ...",
    "Purple": "\u0160krlatna",
    "Quotations": "Citati",
    "R": "R",
    "Range 0 to 255": "Razpon od 0 to 255",
    "Red": "Rde\u010da",
    "Red component": "Rde\u010da komponenta",
    "Redo": "Ponovno uveljavi",
    "Remove": "Odstrani",
    "Remove color": "Odstrani barvo",
    "Remove link": "Odstrani povezavo",
    "Replace": "Zamenjaj",
    "Replace all": "Zamenjaj vse",
    "Replace with": "Zamenjaj z",
    "Resize": "Spremeni velikost",
    "Restore last draft": "Obnovi zadnji osnutek",
    "Reveal or hide additional toolbar items": "Poka\u017eite ali skrijte dodatne elemente orodne vrstice",
    "Rich Text Area": "Rich Text Area",
    "Rich Text Area. Press ALT-0 for help.": "Bogato besedilo. Pritisnite ALT-0 za pomo\u010d.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Bogato besedilo. Pritisnite ALT-F9 za meni. Pritisnite ALT-F10 za orodno vrstico. Pritisnite ALT-0 za pomo\u010d",
    "Ridge": "Greben",
    "Right": "Desna",
    "Right to left": "Od desne proti levi",
    "Row": "Vrstica",
    "Row clipboard actions": "Dejanja odlo\u017ei\u0161\u010da v vrstici",
    "Row group": "Grupiranje vrstic",
    "Row header": "Glava vrstice",
    "Row properties": "Lastnosti vrstice",
    "Row type": "Tip vrstice",
    "Rows": "Vrstice",
    "Save": "Shrani",
    "Save (if save plugin activated)": "Shrani (\u010de je aktiviran vti\u010dnik za shranjevanje)",
    "Scope": "Obseg",
    "Search": "Iskanje",
    "Select all": "Izberi vse",
    "Select...": "Izberi ...",
    "Selection": "Izbor",
    "Shortcut": "Bli\u017enjica",
    "Show blocks": "Prika\u017ei bloke",
    "Show caption": "Poka\u017ei napis",
    "Show invisible characters": "Prika\u017ei skrite znake",
    "Size": "Velikost",
    "Solid": "Polno",
    "Source": "Pot",
    "Source code": "Izvorna koda",
    "Special Character": "Poseben znak",
    "Special character...": "Poseben znak ...",
    "Split cell": "Razdeli celico",
    "Square": "Kvadrat",
    "Start list at number": "Za\u010dni seznam s \u0161tevilko",
    "Strikethrough": "Pre\u010drtano",
    "Style": "Slog",
    "Subscript": "Podpisano",
    "Superscript": "Nadpisano",
    "Switch to or from fullscreen mode": "Preklopi v ali iz celozaslonskega na\u010dina",
    "Symbols": "Simboli",
    "System Font": "Sistemska pisava",
    "Table": "Tabela",
    "Table caption": "Naslov tabele",
    "Table properties": "Lastnosti tabele",
    "Table styles": "Slogi tabele",
    "Template": "Predloga",
    "Templates": "Predloge",
    "Text": "Besedilo",
    "Text color": "Barva besedila",
    "Text color {0}": "Barva besedila {0}",
    "Text to display": "Besedilo za prikaz",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": 'Vneseni URL predstavlja e-po\u0161tni naslov. Ali \u017eelite dodati potrebno predpono "mailto:"?',
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": 'Vneseni URL predstavlja zunanjo povezavo. Ali \u017eelite dodati predpono "http://"?',
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Vneseni URL naslov predstavlja zunanjo povezavo. Ali mu \u017eelite dodati predpono https:// ?",
    "Title": "Naslov",
    "To open the popup, press Shift+Enter": "Za odpiranje pojavnega okna pritisnite Shift + Enter.",
    "Toggle accordion": "Preklopi harmoniko",
    "Tools": "Orodja",
    "Top": "Vrh",
    "Travel and Places": "Potovanja in kraji",
    "Turquoise": "Turkizna",
    "Underline": "Pod\u010drtano",
    "Undo": "Razveljavi",
    "Upload": "Nalo\u017ei",
    "Uploading image": "Nalaganje slike",
    "Upper Alpha": "Velika alfa",
    "Upper Roman": "Velike rimske \u0161tevilke",
    "Url": "Povezava",
    "User Defined": "Uporabnik dolo\u010den",
    "Valid": "Veljavno",
    "Version": "Razli\u010dica",
    "Vertical align": "Navpi\u010dna poravnava",
    "Vertical space": "Navpi\u010dni prostor",
    "View": "Pogled",
    "Visual aids": "Vizualni pripomo\u010dki",
    "Warn": "Opozorilo",
    "White": "Bela",
    "Width": "\u0160irina",
    "Word count": "\u0160tevilo besed",
    "Words": "Besede",
    "Words: {0}": "Besed: {0}",
    "Yellow": "Rumena",
    "Yes": "Da",
    "You are using {0}": "Uporabljate {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Imate neshranjene spremembe. Ste prepri\u010dati, da \u017eelite zapustiti stran?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Varnostne nastavitve brskalnika ne dopu\u0161\u010dajo direktnega dostopa do odlo\u017ei\u0161\u010da. Uporabite kombinacijo tipk Ctrl + X/C/V na tipkovnici.",
    "alignment": "poravnava",
    "austral sign": "znak za austral",
    "cedi sign": "znak za cedi",
    "colon sign": "znak za dvopi\u010dje",
    "cruzeiro sign": "znak za cruzeiro",
    "currency sign": "znak za valuto",
    "dollar sign": "znak za dolar",
    "dong sign": "znak za dong",
    "drachma sign": "znak za drahmo",
    "euro-currency sign": "znak za evro",
    "example": "primer",
    "formatting": "oblikovanje",
    "french franc sign": "znak za francoski frank",
    "german penny symbol": "znak za nem\u0161ki peni",
    "guarani sign": "znak za guarani",
    "history": "zgodovina",
    "hryvnia sign": "znak za hrivnijo",
    "indentation": "zamik",
    "indian rupee sign": "znak za indijsko rupijo",
    "kip sign": "znak za kip",
    "lira sign": "znak za liro",
    "livre tournois sign": "znak za livre tournois",
    "manat sign": "znak za manat",
    "mill sign": "znak za mill",
    "naira sign": "znak za nairo",
    "new sheqel sign": "znak za novi \u0161ekl",
    "nordic mark sign": "znak za nordijsko marko",
    "peseta sign": "znak za peseto",
    "peso sign": "znak za peso",
    "ruble sign": "znak za rubelj",
    "rupee sign": "znak za rupijo",
    "spesmilo sign": "znak za spesmilo",
    "styles": "slogi",
    "tenge sign": "znak za tenge",
    "tugrik sign": "znak za tugrik",
    "turkish lira sign": "znak za tur\u0161ko liro",
    "won sign": "znak za won",
    "yen character": "znak za jen",
    "yen/yuan character variant one": "znak za jen/yuan, prva razli\u010dica",
    "yuan character": "znak za yuan",
    "yuan character, in hong kong and taiwan": "znak za yuan, v Hongkongu in na Tajvanu",
    "{0} characters": "{0} znakov",
    "{0} columns, {1} rows": "{0} stolpcev, {1} vrstic",
    "{0} words": "{0} besed"
});